(function(angular){
	'use strict';
	
	angular
		.module('reitElementListingModule')
		.controller('ReitElementModalController', [
			'$window',
			'APP_BASE_PATH',
			'close',
			'ignoreClose',
			'reitElement',
			'mixpanelFactory',
			ReitElementModalControllerFunction
		]);
	
	function ReitElementModalControllerFunction(
		$window,
		APP_BASE_PATH,
		close,
		ignoreClose,
		reitElement,
		mixpanelFactory) {
		
		var reitElementModal = this;
		reitElementModal.reitElement = reitElement;
		reitElementModal.close = close;
		reitElementModal.ignoreClose = ignoreClose;

		var mixpanelObj = {};

		if(reitElement.elementId) {
			mixpanelObj['Reit Element ID'] = reitElement.elementId;
		} else if (reitElement.id) {
			mixpanelObj['Reit Element ID'] = reitElement.id;
		}
		
		mixpanelFactory.track('Reit Element Modal Opened', mixpanelObj);

		if(reitElement.thumbnailUrl) {
			reitElementModal.imageUrl = reitElement.thumbnailUrl + ', ' + reitElement.coverPhotoUrl + '_md';
		} else {
			reitElementModal.imageUrl = reitElement.coverPhotoUrl;
		}

		if(reitElement.elementId) {
			reitElement.linkUrl = APP_BASE_PATH + '/real-estate-assets/' + reitElement.elementId + '/view';
		} else if (reitElement.id) {
			reitElement.linkUrl = APP_BASE_PATH + '/real-estate-assets/' + reitElement.id + '/view';
		}
	}
})(window.angular);